import { render } from "./Menu.vue?vue&type=template&id=10b25744"
import script from "./Menu.vue?vue&type=script&lang=js"
export * from "./Menu.vue?vue&type=script&lang=js"
script.render = render

export default script